import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';

export const personalInfo = [
    {
        id: "presonalInfo0",
        icon: <LocationOnIcon fontSize="small" className="footerItemIcon" />,
      content: "Milan, Italy",
    },
    {
      id: "presonalInfo1",
      icon: <LocalPhoneIcon fontSize="small" className="footerItemIcon" />,
      content: "+39 327 537 3956",
    },
    {
      id: "presonalInfo2",
      icon: <EmailIcon fontSize="small" className="footerItemIcon" />,
      content: "marco.braggion92@gmail.com",
    },
  ];